import React, { TextareaHTMLAttributes } from 'react';
import { TextAreaSC } from './text-area.styled';

type TTextAreaProps = {
  error?: boolean;
  variation?: 'lined';
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea: React.FC<TTextAreaProps> = ({
  disabled,
  error,
  variation = 'lined',
  ...otherProps
}) => {
  const inputRef = React.useRef<HTMLTextAreaElement | null>(null);

  return (
    <TextAreaSC error={error} disabled={disabled} variation={variation}>
      <textarea ref={inputRef} {...otherProps} />
    </TextAreaSC>
  );
};

export default TextArea;
